var _createForOfIteratorHelper = require("/vercel/path0/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;
function promisfy(fn, ctx) {
  return function () {
    var args = arguments;
    return new Promise(function (resolve, reject) {
      function callback(e) {
        if (e) {
          reject(e);
        } else {
          for (var _len = arguments.length, result = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            result[_key - 1] = arguments[_key];
          }
          if (result.length == 1) {
            resolve(result[0]);
          } else {
            resolve(result);
          }
        }
      }
      var fnArgs = [];
      var _iterator = _createForOfIteratorHelper(args),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          fnArgs.push(i);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      fnArgs.push(callback);
      fn.apply(ctx, fnArgs);
    });
  };
}

// for callbacks without error for its first argument
function promisfyNoError(fn, ctx) {
  return function () {
    var args = arguments;
    return new Promise(function (resolve, reject) {
      function callback(result) {
        resolve(result);
      }
      var fnArgs = [];
      var _iterator2 = _createForOfIteratorHelper(args),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var i = _step2.value;
          fnArgs.push(i);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      fnArgs.push(callback);
      fn.apply(ctx, fnArgs);
    });
  };
}
function waitFor(obj, evt) {
  function normalEvent(resolve, reject) {
    function callback(e, result) {
      if (e) {
        reject(e);
      } else {
        resolve(result);
      }
    }
    obj.on(evt, callback);
  }

  // TODO:
  // fix possible encoding error
  function streamDataEvent(resolve, reject) {
    var data = '';
    var hasError = false;
    obj.on('data', function (chunk) {
      data += chunk;
    });
    obj.on('end', function () {
      if (!hasError) {
        resolve(data);
      }
    });
    obj.on('error', function (err) {
      reject(err);
    });
  }
  if (evt === 'data' || evt === 'stream') {
    return new Promise(streamDataEvent);
  } else {
    return new Promise(normalEvent);
  }
}
exports.promisfy = promisfy;
exports.waitFor = waitFor;
exports.promisfyNoError = promisfyNoError;